declare namespace $ {

	export class $shm_button_copy extends $mol_button_copy {
		Icon( ): $mol_icon_content_copy
		title( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=copy.view.tree.d.ts.map